import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const CandidateScreeningHelp = () => {
  const isMdScreen = IsMdScreen();

  return (
    <Stack direction="row" spacing={2} sx={{ height: '100%' }}>
      <ShContainer maxWidth='xl' sx={{ flex: 1 }}>
        <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
          Candidate Screening
        </ResourceTypography>
        <ResourceTypography variant="body1" paragraph>
          Streamline your candidate screening process with automated tools and best practices.
          Learn how to efficiently evaluate candidates and identify the best matches for your roles.
        </ResourceTypography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Automated Screening
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Set up automated screening criteria to filter candidates based on qualifications,
          experience, and other requirements. Save time on initial candidate evaluation.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Resume Parsing
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Use our advanced resume parsing technology to extract key information from resumes
          and automatically populate candidate profiles with relevant data.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Skills Assessment
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Create and administer skills assessments to evaluate candidate capabilities.
          Use pre-built tests or create custom assessments for specific roles.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Screening Workflows
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Design custom screening workflows to match your hiring process. Set up stages,
          assign reviewers, and track candidate progress through the screening process.
        </Typography>

        <Box paddingTop={2} paddingBottom={3}>
          <ShButton
            component={RouterLink}
            to="/employer/settings/automation/screening"
            color="primary"
            variant="contained"
          >
            Configure Screening Settings
          </ShButton>
        </Box>
      </ShContainer>
      {!isMdScreen && <CommonQuestionSidebar />}
    </Stack>
  );
};

export default CandidateScreeningHelp; 